import { CommonModule, DatePipe } from '@angular/common';
import {
    Component,
    inject,
    input,
    OnChanges,
    output
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDividerModule } from '@angular/material/divider';
import { Router } from '@angular/router';
import { Setting } from '../../classes/setting';
import { AppService } from '../../services/app.service';
import { SnackBarService } from '@polk_county_public_schools/ngx-pcps-dialogs/snackbar';
import { UserInfo, UserService } from '../../services/user.service';

@Component({
    selector: 'app-instructions',
    templateUrl: './instructions.component.html',
    styleUrls: ['./instructions.component.scss'],
    standalone: true,
    imports: [
        MatButtonModule,
        MatDividerModule,
        MatCheckboxModule,
        FormsModule,
        MatCardModule,
        CommonModule
    ]
})
export class InstructionsComponent implements OnChanges {
    protected readonly appSvc = inject(AppService);
    protected readonly datePipe = inject(DatePipe);
    protected readonly router = inject(Router);
    protected readonly snackBarSvc = inject(SnackBarService);
    protected readonly userSvc = inject(UserService);

    instructionsRead = input.required<boolean>();
    settings = input.required<Setting[]>();
    deadlineException = input<boolean>(false);
    user = input<UserInfo | null>(null);
    action = output<string>();

    taxYear1: number;
    taxYear2: number;
    schoolYear: string;
    startDate: string;
    endDate: string;
    endDateDisplay: string;
    endDateMonthDay: string;
    pastDeadline: boolean = false;
    checkboxes: boolean[] = [false, false, false, false];
    invalidForm: boolean = false;
    isStudent: boolean = false;

    ngOnChanges() {
        // Setup the properties used by the component based on the loaded settings.
        if (this.settings() == null) return;

        this.startDate = this.settings().find(
            (f) => f.Label === 'Scholarship app start date'
        ).Value;
        this.endDate = this.settings().find(
            (f) => f.Label === 'Scholarship app end date'
        ).Value;
        this.endDateDisplay = this.settings().find(
            (f) => f.Label === 'Scholarship app end date (display)'
        ).Value;
        let deadline = new Date(this.endDate);
        this.endDateMonthDay = this.datePipe.transform(deadline, 'MMMM d');
        this.schoolYear = this.settings()
            .find((f) => f.Label === 'School year (scholarship entry)')
            .Value.substring(4);
        this.taxYear2 = +this.schoolYear - 1;
        this.taxYear1 = this.taxYear2 - 1;
        this.pastDeadline = new Date() > deadline;

        this.isStudent = this.user()?.RoleBooleans?.IsStudent === true;
    }

    goToApplication() {
        if (this.checkboxes.some((c) => c === false)) {
            this.invalidForm = true;
            return;
        }

        this.action.emit('student-application');
    }

    back() {
        let route: string;

        if (this.isStudent === true && (this.pastDeadline === false || this.deadlineException() === true)) {
            route = 'student-application';
        }
        //not student, but logged in
        else if (this.user() != null) {
            route = 'admin-home';
        }
        else {
            route = 'login';
        }

        this.action.emit(route);
    }
}
